/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-07-03 07:32:54
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import { store } from 'src/stores/store';

/**
 * Get app admin feature
 *
 * @param  {string} name feature name
 *
 * @return {boolean}      true | false
 */
export function getAppAdminFeatures(name) {
  const currentState = store.getState();
  const adminAppFeatures = _.get(currentState.oauth.tenantApp, 'adminAppFeatures', {});
  const featureFlag = _.get(adminAppFeatures, name, false);

  return featureFlag;
}

/**
 * Get app admin feature
 *
 * @param  {string} name feature name
 *
 * @return {boolean}      true | false
 */
export function getFeatures(name) {
  const currentState = store.getState();
  const features = _.get(currentState.oauth.tenantApp, 'features', {});
  const featureFlag = _.get(features, name, false);

  return featureFlag;
}
